import { render, staticRenderFns } from "./NewRequestFacade.vue?vue&type=template&id=4965313a&scoped=true"
import script from "./NewRequestFacade.vue?vue&type=script&lang=ts"
export * from "./NewRequestFacade.vue?vue&type=script&lang=ts"
import style0 from "./NewRequestFacade.vue?vue&type=style&index=0&id=4965313a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4965313a",
  null
  
)

export default component.exports